<template>
  <v-dialog
    persistent
    v-model="dialogDelete"
    width="600"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        outlined
        color="red"
        v-bind="attrs"
        v-on="on"
      >
        {{ title }}
      </v-btn>
    </template>
    <v-card>
      <div class="pa-6">
        <div>
          <h2 class="delete-title">
            Voulez-vous vraiment procéder à la suppression?
          </h2>
          <div class="danger-zone pb-2">
            <span class="danger-warning">
              ⚠
            </span> Opération non réversible.
          </div>
          <div class="mt-1 mb-6">
            <v-divider />
          </div>
          <div>
            <span class="pr-2 delete-font-title">
              Nom:
            </span>
            <span class="delete-font-content">
              {{ entityName }}
            </span>
          </div>
          <div>
            <span class="pr-2 delete-font-title">
              ID:
            </span>
            <span class="delete-font-content">
              {{ entityId }}
            </span>
          </div>
        </div>
        <div class="d-flex justify-end pt-5">
          <v-btn
            outlined
            color="primary"
            @click.stop="dialogDelete = false"
            class="ma-2"
          >
            Annuler
          </v-btn>
          <v-btn
            dark
            color="red"
            class="ma-2"
            @click.stop="$emit('deleted')"
          >
            Supprimer
          </v-btn>
        </div>
      </div>
      <div>
        <slot />
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'DeleteDialog',
  props: {
    title: {
      type: String,
      required: true,
    },
    entityId: {
      type: String,
      required: true,
    },
    entityName: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      dialogDelete: false,
    };
  },
};
</script>
<style scoped>
.danger-zone {
  font-size: 16px;
  font-weight: 600;
  color: red;
}
.delete-title {
  font-size: 24px;
  font-weight: 500;
  color: black;
}
.delete-font-title {
  font-size: 16px;
  font-weight: 600;
  color: black;
}
.delete-font-content {
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
  color: black;
}
.danger-warning {
  color: #e07e21;
}
</style>
